import { activityTypes } from "../../../helpers/get_constants";

export default {
  timeline: [],
  timelineIds: [],
  timelineTicketIds: [],
  contactTimeline: [],
  contactTlineIds: [],
  commentTypes: {
    [activityTypes.COMMENT]: {
      id: activityTypes.COMMENT,
      icon: "fas fa-comment",
      color: "pink",
      allow_user: true,
    },
    [activityTypes.CALL]: {
      id: activityTypes.CALL,
      icon: "fas fa-headset",
      color: "cyan",
      allow_user: true,
    },
    [activityTypes.COMMENT_BY_AGENT]: {
      id: activityTypes.COMMENT_BY_AGENT,
      icon: "fas fa-comment",
      color: "orange",
      allow_user: true,
    },
    [activityTypes.EVENT]: {
      id: activityTypes.EVENT,
      icon: "far fa-calendar-alt",
      color: "purple",
      allow_user: true,
    },
    [activityTypes.CONTACT]: {
      id: activityTypes.CONTACT,
      icon: "fas fa-user",
      color: "teal",
    },
    [activityTypes.WHATSAPP]: {
      id: activityTypes.WHATSAPP,
      icon: "fab fa-whatsapp",
      color: "#25D366",
      allow_user: true,
    },
  },
};
